import { render, staticRenderFns } from "./EmergencyPhone.vue?vue&type=template&id=9c1f29ae&"
import script from "./EmergencyPhone.vue?vue&type=script&lang=js&"
export * from "./EmergencyPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports